import React from 'react';
import { View } from 'react-native';
import AdminInfoBanner from '../../../Admin/components/AdminInfoBanner';
import { CONFLICT_MESSAGE } from '../constants';
import { usePeopleConfig } from '../PeopleConfigContext';

interface TabBodyProps {
  children: React.ReactNode;
}

/** Wrapper for every tab: optimistic-lock conflict banner, last save error, then content. */
const TabBody: React.FC<TabBodyProps> = ({ children }) => {
  const { conflict, saveError } = usePeopleConfig();
  return (
    <View style={{ gap: 20 }}>
      {conflict ? <AdminInfoBanner variant="warn" message={CONFLICT_MESSAGE} /> : null}
      {saveError ? <AdminInfoBanner variant="warn" message={saveError} /> : null}
      {children}
    </View>
  );
};

export default TabBody;
